import { flow, makeAutoObservable } from 'mobx';
import { LOOKUP_USER_BY_EMAIL_QUERY } from '@graphql';
import { graphqlApi } from '@utils';
import { store } from '@store';
import { DEFAULT_HTTP_RESPONSE } from './defaults';

export class UsersStore {
  lookupResult: any = null;

  lookupResponse: HttpResponse = DEFAULT_HTTP_RESPONSE;

  constructor() {
    makeAutoObservable(this);
  }

  resetLookup = () => {
    this.lookupResult = null;
    this.lookupResponse = DEFAULT_HTTP_RESPONSE;
  };

  lookupUserByEmail = flow(function* lookupUserByEmail(this: UsersStore, email: string): any {
    // Cleared up front so a failed lookup never leaves the previous user on screen.
    this.lookupResult = null;
    this.lookupResponse.errMessage = '';
    try {
      this.lookupResponse.status = 'pending';
      const response = yield graphqlApi(LOOKUP_USER_BY_EMAIL_QUERY, { email });

      const errorMessage = response?.data?.errors?.[0]?.message;
      if (errorMessage === 'Unauthorized') {
        store.userStore.clearSession();
        return null;
      }
      // Any other GraphQL error means the lookup did not run, which is not the same as no match.
      if (errorMessage) {
        this.lookupResponse.status = 'badRequest';
        this.lookupResponse.errMessage = errorMessage;
        return null;
      }

      this.lookupResponse.status = 'ok';
      this.lookupResult = response?.data?.data?.lookupUserByEmail ?? null;
      return this.lookupResult;
    } catch (err) {
      this.lookupResponse.status = 'badRequest';
      this.lookupResponse.errMessage = 'Bad Request';
      return null;
    }
  }).bind(this);
}
